import { createFileRoute } from "@tanstack/react-router";
import AdminSetDetailPage from "@/pages/admin/sets/detail";
import { useSetsPermissions } from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets/$setId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { setId } = Route.useParams();
  const { userCanEditAllSets, userCanViewAllSets, userCanViewAllPrograms, userCanViewAllCriteria } = useSetsPermissions();

  return (
    <AdminSetDetailPage
      setId={Number(setId)}
      userCanEditAllSets={userCanEditAllSets}
      userCanViewAllSets={userCanViewAllSets}
      userCanViewAllPrograms={userCanViewAllPrograms}
      userCanViewAllCriteria={userCanViewAllCriteria}
    />
  );
}
